import {
  GET_PULLOUT_ITEMS,
  GET_PULLOUT_DATA,
  LOAD_MORE_PULLOUT_DATA
} from "../types";
import axios from "axios";
import {firebase} from '../../../firebase/initFirebase'
import moment from 'moment'
import {store} from '../../store'
import { message} from 'antd';
import S3 from 'react-aws-s3';


export const getPullOutData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var userLocation = reduxState.auth.user.branch
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('pullout') 
    var userLocationName = reduxState.auth.user.branch_name

      // console.log(props)
    
      dataRef = dataRef.orderBy("created_at","desc")
 
      dataRef = dataRef.where("status", "==", "completed")        
       
      

      if(userRole !== 'admin' && userRole !== 'manager'){
        dataRef = dataRef.where("branch", "==", userLocation)   
      }

 
      // if(props.searchText){
      //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
      // }
      // if(props.filters){
      //   if(props.filters.length > 0){
      //     props.filters.map(item=>{
      //       console.log(item)
      //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
      //     })
      //   }       
      // }

      dataRef = dataRef.limit(40)
    
      var documentSnapshots = await dataRef.get()
      var docs = documentSnapshots.docs
      var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
      var dataArray =[]

      await Promise.all(docs.map(async (salesItem) => {    
        var newOrder={
            key:salesItem.id,
            id:salesItem.id,
            ...salesItem.data()
        }

   

        dataArray.push(newOrder)
      }));
      dispatch({ type: GET_PULLOUT_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible, currentProps:props } }) 

      
  };
};

export const loadMorePullOutData = () => {
  return async(dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email
    var currentLastItem = reduxState.dailysales.lastVisible
    var userLocation = reduxState.auth.user.branch
    var currentProps = reduxState.dailysales.currentProps
    var Firestore = firebase.firestore();
    var userLocationName = reduxState.auth.user.branch_name
    
    var dataRef = Firestore.collection(currentProps.apiurl) 

      dataRef = dataRef.orderBy("created_at","desc") 
          
      dataRef = dataRef.where("status", "==", "completed")    
    
      if(userRole !== 'admin' && userRole !== 'manager'){
        dataRef = dataRef.where("branch", "==", userLocation)   

      }

      if(currentLastItem){
        dataRef = dataRef.startAfter(currentLastItem)
              
      
        // if(currentProps.searchText){
        //   dataRef = dataRef.where('name', '>=', currentProps.searchText).where('name', '<=', currentProps.searchText+ '\uf8ff')
        // }

        dataRef = dataRef.limit(100)
 
        var documentSnapshots = await dataRef.get()
        var docs = documentSnapshots.docs
        if(docs){
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
          var dataArray =[]
          await Promise.all(docs.map(async (salesItem) => {    
            var newOrder={
                key:salesItem.id,
                id:salesItem.id,
                ...salesItem.data()
            }
  
     
            dataArray.push(newOrder)
          }));
          if(lastVisible && currentLastItem !== lastVisible){

            dispatch({ type: LOAD_MORE_PULLOUT_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible} })  
          }else{
            message.error('No More Orders To Load');
          }
        }else{
          message.error('No More Orders To Load');
        }
    }
  };
};





export const getPullOutItems = (props) => {
  return async(dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var userLocation = reduxState.auth.user.branch
    var Firestore = firebase.firestore();
    var inventory_dataref = Firestore.collection('inventory')
      // console.log(props)
   
    console.log(userLocation)
      inventory_dataref = inventory_dataref.where("location", "==", userLocation)

      var documentSnapshots = await inventory_dataref.get()
    
      var proddocs = documentSnapshots.docs
      var newProds = []

      await Promise.all(proddocs.map(async (item) => {  
 
        var newProd={
          inventory_key:item.id,
          inventory_id:item.id,
     
          ...item.data()
        } 

        if(newProd.product && newProd.quantity > 0){
          var productdataref = Firestore.collection('products').doc(newProd.product)
          var productdatadocs = await productdataref.get()

          if(productdatadocs){      
            newProd = {
              ...newProd,
              ...productdatadocs.data()
            }   
            if(newProd.name)
            newProds.push(newProd)
          }
        }

      }))
      dispatch({ type: GET_PULLOUT_ITEMS, payload:newProds }) 
 
  };
};



export const setPullOut = (pullout_items,createDate) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name


    var wasteRef = Firestore.collection('pullout').doc()
 
  
    var salesData = { 
      status: 'completed',
      created_at: createDate.format('YYYY-MM-DD HH:mm:ss'),      
      created_by:userID,
      created_name:userName, 
      branch:userLocation,
      branch_name:userLocationName,
      pullout_items: pullout_items

    }
    console.log(salesData)

    var salesndone = await wasteRef.set(salesData,{merge: true})

    return('oks')
  };
};

